import api from './client';
import type { Payment, Facture } from 'types/payment';

export interface CreatePaymentData {
  ordre_id: string;
  type: 'acompte' | 'solde';
  amount: number;
  reglement_infos: {
    email: string;
    phone?: string;
    name: string;
    first_name?: string;
  };
  invoice_gcs_path?: string;
}

export const paymentsApi = {
  create: async (data: CreatePaymentData): Promise<Payment> => {
    const { data: result } = await api.post('/payments', data);
    return result;
  },

  listForOrdre: async (ordreId: string): Promise<Payment[]> => {
    const { data } = await api.get('/payments', { params: { ordre_id: ordreId } });
    return data;
  },

  listAll: async (): Promise<Payment[]> => {
    const { data } = await api.get('/payments');
    return data;
  },

  listFactures: async (): Promise<Facture[]> => {
    const { data } = await api.get('/payments/factures');
    return data;
  },

  get: async (id: string): Promise<Payment> => {
    const { data } = await api.get(`/payments/${id}`);
    return data;
  },

  cancel: async (id: string): Promise<Payment> => {
    const { data } = await api.post(`/payments/${id}/cancel`);
    return data;
  },

  resend: async (id: string): Promise<Payment> => {
    const { data } = await api.post(`/payments/${id}/resend`);
    return data;
  },
};
